import { Grid } from '@mui/material';
import CampaignIcon from '@mui/icons-material/Campaign';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PhoneIcon from '@mui/icons-material/Phone';
import DescriptionIcon from '@mui/icons-material/Description';
import DrawIcon from '@mui/icons-material/Draw';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import EventIcon from '@mui/icons-material/Event';
import PhoneMissedIcon from '@mui/icons-material/PhoneMissed';
import StatCard from './StatCard';
import { formatMoney } from '../utils';

const AttributionCards = ({ data }) => {
  const { totals, sources, attribution } = data;
  const o = totals.overall;
  const callRailPct = attribution.total > 0 ? ((attribution.callRailAttributed / attribution.total) * 100).toFixed(0) : '0';
  const answerRate = o.calls > 0 ? ((o.answeredCalls / o.calls) * 100).toFixed(0) : '0';

  return (
    <>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Sources"
            value={sources.length}
            icon={<CampaignIcon sx={{ color: '#0d3c61', fontSize: 28 }} />}
            color="#0d3c61"
            subtitle={`${attribution.callRailAttributed} CallRail / ${attribution.crmFallback} CRM`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Revenue"
            value={formatMoney(o.totalRevenue)}
            icon={<AttachMoneyIcon sx={{ color: '#2e7d32', fontSize: 28 }} />}
            color="#2e7d32"
            subtitle={`Paid: ${formatMoney(totals.paid.totalRevenue)} | Organic: ${formatMoney(totals.organic.totalRevenue)}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Calls"
            value={o.calls}
            icon={<PhoneIcon sx={{ color: '#1565c0', fontSize: 28 }} />}
            color="#1565c0"
            subtitle={`${o.firstTimeCalls} first-time | ${answerRate}% answered`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Appointments"
            value={o.appointments}
            icon={<EventIcon sx={{ color: '#ff9800', fontSize: 28 }} />}
            color="#ff9800"
            subtitle={`${o.matchedToClient} matched to client`}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="HIC Proposals"
            value={o.hicProposals}
            icon={<DescriptionIcon sx={{ color: '#0d3c61', fontSize: 28 }} />}
            color="#0d3c61"
            subtitle={`${o.hicSold} sold | ${formatMoney(o.hicRevenue)}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="SVC Proposals"
            value={o.svcProposals}
            icon={<DrawIcon sx={{ color: '#7b1fa2', fontSize: 28 }} />}
            color="#7b1fa2"
            subtitle={formatMoney(o.svcRevenue)}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Missed Calls"
            value={o.missedCalls}
            icon={<PhoneMissedIcon sx={{ color: '#e53935', fontSize: 28 }} />}
            color="#e53935"
            subtitle={o.calls > 0 ? `${((o.missedCalls / o.calls) * 100).toFixed(0)}% miss rate` : ''}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Attribution"
            value={`${callRailPct}%`}
            icon={<TrackChangesIcon sx={{ color: '#00695c', fontSize: 28 }} />}
            color="#00695c"
            subtitle={`${attribution.callRailAttributed} of ${attribution.total} via CallRail`}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AttributionCards;
